const UPDATE_CANCELLATION_REASON = gql`
    mutation UpdateCancellationReason($input: UpdateCancellationReasonInput!) {
        updateCancellationReason(input: $input) {
            message
        }
    }
`;
export default UPDATE_CANCELLATION_REASON;
